/*python接口*/
import axios from '../index'
import api from './run.api'
var querystring = require('querystring')

export default {
  /**
   * @param { String } codeStr
   * @return {Data: {cmdstr: "代码运行结果", msg: "特定函数调用结果列表"}}
   */
  RunCode(codeStr) {
    return axios({
      url: api.serviceRun,
      method: 'post',
      headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        withCredentials: true,
      },
      data: querystring.stringify({
        codeStr: codeStr,
      }),
    })
  },
  /**
   * @param { String } codeStr 脚本
   * @param { String } fileid  uuid
   * @return
   */
  RunCodeGl(data) {
    return axios({
      url: api.serviceRunGl,
      method: 'post',
      headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        withCredentials: true,
      },
      data: data,
    })
  },
  /**
   * @param { String } codeStr 脚本
   * @param { String } fileid  uuid
   * @return
   */
  TerminateGl(data) {
    return axios({
      url: api.terminateGl,
      method: 'post',
      headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        withCredentials: true,
      },
      data: data,
    })
  },
  /**
   * @param { String } codeStr
   * @return {Data: {cmdstr: "代码运行结果", msg: "特定函数调用结果列表"}}
   */
  RunPJ(codeStr) {
    let formData = new FormData()
    formData.append('codeStr', codeStr)
    return axios({
      url: api.pjRun,
      method: 'post',
      headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        withCredentials: true,
      },
      data: formData,
    })
  },
}
